<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-2 p-pb-1">
      <div class="p-grid p-nogutter" style="min-height: 75px;">
        <div class="p-col">
          <div class="p-grid p-ai-center vertical-container">
              <div class="p-col-fixed" style="width:55px;">
                  <a @click="$functions.historyBack()" style="cursor: pointer">
                    <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
                  </a>
              </div>
              <div class="p-col">
                  <h3>{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</h3>
              </div>
          </div>
        </div>
        <div v-if="!readOnlyMode" class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="(mfCycleRunning && appliance && appliance.cycleLibrary === true)" :label="$t('library.cycle.stop_button')" @click="() => {dialog.stop = true;}"  />
        </div>
      </div>
        
        <div v-if="(mfCycleRunning && recipe)" class="irinox-form recipe-running " style="overflow-x: hidden; margin: 0 -2rem;">

          <div class="fade-left"/>
          <div class="fade-right"/>

          <vueper-slides ref="phases" class="no-shadow ex--center-mode" 
              arrows-outside :bullets="false" 
              transition-speed="250" :infinite="false"
              :dragging-distance="70" 
              :slideRatio="1/1"
              :disableArrowsOnEdges="true"
              @slide="changeSlide('slide', $event)"
              @ready="carouselReady"
              >      

            <template #arrow-left>
              <img src="assets/irinox/icons/carousel_left.svg"   :alt="$t('common.previous')"/>
            </template>

            <template #arrow-right>
              <img src="assets/irinox/icons/carousel_right.svg"   :alt="$t('common.next')"/>
            </template>

            <vueper-slide
                v-for="(phase, i) in recipe.phases"
                :key="'carousel_phase_'+i"
                :content="'carousel_phase_content_'+i"
                :style="'background-color: white'" 
                >
              <template #content>

                <div :class="['phase', phaseTypeClass(phase.type), {'phase-running':(i==mfCyclePhaseNumber)}]">

                  <div v-if="isSpecialPhase(phase.type)" :class="['phase-header']">{{$t('mf.phases.'+phase.type).toUpperCase()}}</div>
                  <div v-else :class="['phase-header']">{{(i).toString().padStart(2, '0')}}. {{$t('mf.phases.'+phase.type).toUpperCase()}}</div>

                  <div v-if="(phase.type==2 || phase.type==3)" :class="['phase-body']" >
                    <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                      <span v-if="(phase.type==2)" class="icon-prechilling" style="font-size: 80px"/>
                      <span v-if="(phase.type==3)" class="icon-preheating" style="font-size: 80px"/>

                      <span v-if="(i==mfCyclePhaseNumber)" class="p-m-2">{{$functions.temperature(mfAirSetpoint, isCelsius)}}{{unit}}</span> 
                      <span v-else class="p-m-2">{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span> 
                    </div>
                  </div>
                  
                  <div v-else-if="(phase.type==4)" :class="['phase-body']" >
                    <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                      <span class="icon-air_temp" style="font-size: 80px"/>
                      <span v-if="(i==mfCyclePhaseNumber)" class="p-m-2">{{$functions.temperature(mfAirSetpoint, isCelsius)}}{{unit}}</span> 
                      <span v-else class="p-m-2">{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span> 
                    </div>
                  </div>
                  
                  <div v-else-if="(phase.type==8)" :class="['phase-body']" >
                    <div class="p-d-flex p-flex-column phase-big p-ai-center p-jc-center">
                      <span class="icon-fan" style="font-size: 80px"/>
                      <span v-if="(i==mfCyclePhaseNumber)" class="p-m-2">{{mfFanLevel}}</span> 
                      <span v-else class="p-m-2">{{phase.set_ventilation}}</span> 
                    </div>
                  </div>

                  <div v-else :class="['phase-body']">
                    <div> </div>
                    <div class="setpoint">
                      <div :class="['p-grid', 'p-ai-center']">
                        <div class="p-col-fixed p-text-center">
                          <span class="icon-air_temp"/>
                        </div>
                        <div class="p-col p-text-right">
                          <span v-if="(i==mfCyclePhaseNumber)">{{$functions.temperature(mfAirSetpoint, isCelsius)}}{{unit}}</span>  
                          <span v-else>{{$functions.temperature(phase.set_temp_room*10,isCelsius)}}{{unit}}</span>  
                        </div>
                      </div>
                    </div>
                    <Divider v-if="isCoreVisible(phase)" />
                    <div v-if="isCoreVisible(phase)" class="setpoint">
                      <div :class="['p-grid', 'p-ai-center']">
                        <div class="p-col-fixed p-text-center">
                          <span class="icon-core_temp"/>
                        </div>
                        <div class="p-col p-text-right">
                          <span v-if="(i==mfCyclePhaseNumber)">{{$functions.temperature(mfCoreSetpoint,isCelsius)}}{{unit}}</span>  
                          <span v-else>{{$functions.temperature(phase.set_temp_probe*10,isCelsius)}}{{unit}}</span>  
                        </div>
                      </div>
                    </div>
                    <Divider v-if="isDurationVisible(phase)" />
                    <div class="setpoint" v-if="isDurationVisible(phase)" >
                      <div :class="['p-grid', 'p-ai-center']">
                        <div class="p-col-fixed p-text-center">
                          <span class="icon-time"/>
                        </div>
                        <div class="p-col p-text-right">
                          <span v-if="(i==mfCyclePhaseNumber)">{{mfDuration}}</span> 
                          <span v-else>{{duration(phase)}}</span> 
                        </div>
                      </div>
                    </div>
                    <Divider />
                    <div class="setpoint">
                      <div :class="['p-grid', 'p-ai-center']">
                        <div class="p-col-fixed p-text-center">
                          <span class="icon-fan"/>
                        </div>
                        <div class="p-col p-text-right">
                          <span v-if="(i==mfCyclePhaseNumber)">{{mfFanLevel}}</span> 
                          <span v-else>{{phase.set_ventilation}}</span> 
                        </div>
                      </div>
                    </div>
                    <div> </div>
                  </div>

                  </div>

              </template>
            </vueper-slide>
          </vueper-slides>

          <div v-if="!readOnlyMode" class="cycle-controls p-mt-2">
            
            <div v-if="(currentSlide==mfCyclePhaseNumber)" class="p-grid nested-grid p-jc-center controls">
              <div class="p-col-fixed">
                <Control v-model="setpoints.temperature" icon="icon-air_temp" :isTemperature="true" 
                  :min="limits.cellSetTempMin" 
                  :max="limits.cellSetTempMax" 
                  @update:modelValue="startProgress" />
              </div>
              <div v-if="isCoreVisible(recipe.phases[currentSlide])" class="p-col-fixed">
                <Control v-model="setpoints.core" icon="icon-core_temp" :isTemperature="true" 
                  :min="limits.coreProbeSetTempMin" 
                  :max="limits.coreProbeSetTempMax" 
                  @update:modelValue="startProgress" />
              </div>
              <div v-if="isDurationVisible(recipe.phases[currentSlide])" class="p-col-fixed">
                <Control v-model="setpoints.time" icon="icon-time" :isTime="true" 
                  :min="limits.phaseDurationSetMin" 
                  :max="limits.phaseDurationSetMax" 
                  @update:modelValue="startProgress"/>
              </div>
              <div class="p-col-fixed">
                <Control v-model="setpoints.fan" icon="icon-fan" 
                  :min="limits.evapFanSetSpeedMin" 
                  :max="limits.evapFanSetSpeedMax"
                  @update:modelValue="startProgress"/>
              </div>
            </div>
            <div v-if="(currentSlide>mfCyclePhaseNumber && appliance && appliance.cycleLibrary === true)" class="p-grid nested-grid p-jc-center controls">
              <div class="p-col-fixed">
                <Control v-model="setpoints.temperature" icon="icon-air_temp" :isTemperature="true" 
                  :min="getLimits(recipe.phases[currentSlide].type).cellSetTempMin" 
                  :max="getLimits(recipe.phases[currentSlide].type).cellSetTempMax" 
                  @update:modelValue="startProgress" />
              </div>
              <div v-if="isCoreVisible(recipe.phases[currentSlide])" class="p-col-fixed">
                <Control v-model="setpoints.core" icon="icon-core_temp" :isTemperature="true" 
                  :min="getLimits(recipe.phases[currentSlide].type).coreProbeSetTempMin" 
                  :max="getLimits(recipe.phases[currentSlide].type).coreProbeSetTempMax" 
                  @update:modelValue="startProgress" />
              </div>
              <div v-if="isDurationVisible(recipe.phases[currentSlide])" class="p-col-fixed">
                <Control v-model="setpoints.time" icon="icon-time" :isTime="true" 
                  :min="getLimits(recipe.phases[currentSlide].type).phaseDurationSetMin" 
                  :max="getLimits(recipe.phases[currentSlide].type).phaseDurationSetMax" 
                  @update:modelValue="startProgress"/>
              </div>
              <div class="p-col-fixed">
                <Control v-model="setpoints.fan" icon="icon-fan" 
                  :min="getLimits(recipe.phases[currentSlide].type).evapFanSetSpeedMin" 
                  :max="getLimits(recipe.phases[currentSlide].type).evapFanSetSpeedMax" 
                  @update:modelValue="startProgress"/>
              </div>
            </div>

          </div>

          <div v-show="!mfContinuousCycleRunning" class="cycle-progress-bar p-grid p-mt-2">
            <div v-for="i in appliance.cycle.cycleTotalPhases" :key="'progress-'+i" 
              :class="['p-col','phase-progress-bar',{'phase-progress-bar-done':(i-1)<mfCyclePhaseNumber}]">
                <span v-if="(i-1)==mfCyclePhaseNumber" class="phase-progress-bar-running" :style="'width: '+progressBar+'%'"></span>
            </div>
          </div>

        </div>

        <div v-else>

          {{$t('mf.no_cycle_running')}}

        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.stop" mode="confirm" 
    :leftB="$t('library.cycle.stop_dialog_cancel_button')" @click:left-button="() => {dialog.stop = false;}" 
    :rightB="$t('library.cycle.stop_dialog_ok_button')" @click:right-button="stopCycle" 
    :message="$t('library.cycle.stop_dialog')"
    icon="assets/irinox/icons/play_big.svg" />
  <IrinoxDialogDark :visible="dialog.stopSuccess" 
    mode="success" 
    :message="$t('library.cycle.stop_dialog_success')"
    :life="3000" 
    @update:visible="dialog.stopSuccess = $event" />


</template>

<script>
import ApplianceService from '../../../service/ApplianceService';
import EventHubListenerService from '../../../service/EventHubListenerService';
import RecipeService from '../../../service/RecipeService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
// https://antoniandre.github.io/vueper-slides/?ref=madewithvuejs.com
import { mapGetters } from 'vuex';
import Control from '../Control.vue';
import commands from "../../../../public/json/commands_mf.json"

export default {
    components: {
      IrinoxDialogDark,
      VueperSlides, 
      VueperSlide,
      Control
    },
    data() {
        return {
          serialNumber: this.$route.params.serialNumber,
          commands: commands,
          recipe: null,
          dialog: {
            blockingError: false,
            stop: false,
            stopSuccess: false
          },
          currentSlide: 0,
          setpoints: {
            temperature: 0,
            core: 0,
            humidity: 0,
            time: 0,
            fan: 0,
          },
          progressBar: 100
          // waitingForSaving: null,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        mfCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1;
        },
        mfContinuousCycleRunning: function() {
          return !this.appliance.cycle || !this.appliance.cycle.cycleTimeLeft!=null  || this.appliance.cycle.cycleTimeLeft<=0;
          // return this.mfCycleRunning && this.appliance.cycle.functionRunning && this.appliance.cycle.functionRunning==13;
        },
        mfAirTemp: function() {
          return this.appliance.status && this.appliance.status.TCell!=null ? this.appliance.status.TCell : null;
        },
        mfCoreTemp: function() {
          return this.appliance.status && this.appliance.status.operativeCoreTemperature!=null  ? this.appliance.status.operativeCoreTemperature : null;
        },
        // mfIsCore: function() {
        //   return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        // },
        mfAirSetpoint: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.cellSetTemp : null;
        },
        mfCoreSetpoint: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.coreProbeSetTemp : null;
        },
        mfAirSetpointEnabled: function() {
          return this.limits.cellSetTempMin!=null && this.limits.cellSetTempMax!=null;
        },
        mfCoreSetpointEnabled: function() {
          return this.limits.coreProbeSetTempMin!=null && this.limits.coreProbeSetTempMax!=null;
        },
        mfFanLevel: function() {
          return this.deviceTwin && this.deviceTwin.status ? this.deviceTwin.status.evapFanSetSpeed : null;
        },
        mfDuration: function() {
          if(!this.mfContinuousCycleRunning) {
            try {
              //phaseDurationSet is in seconds
              let time = this.mfCycleRunning && this.deviceTwin.status ? this.deviceTwin.status.phaseDurationSet / 60 : null;
              //time in minutes
              if(time) {
                var hours = Math.floor(time / 60);
                time = time - hours * 60;
                var minutes = Math.floor(time);
                return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
              }
            } catch(err) {
              return "N/A";
            }
          }
          return "--h:--m";
        },
        mfDurationSetpoint: function() {
          return this.mfCycleRunning && this.deviceTwin.status ? this.deviceTwin.status.phaseDurationSet / 60 : 0;
        },
        mfTimeLeft: function() {
          return this.mfCycleRunning && this.appliance.cycle && this.appliance.cycle.cycleTimeLeft ? this.appliance.cycle.cycleTimeLeft / 60 : 0;
        },
        // mfPercentage: function() {
        //   if(this.mfDurationSetpoint>0 && this.mfTimeLeft>0) {
        //     return (this.mfDurationSetpoint-(this.mfTimeLeft/60)) * 100 / this.mfDurationSetpoint;
        //   } else {
        //     return 0;
        //   }
        // },
        mfCyclePhaseNumber: function() {
          return this.appliance.cycle.cyclePhaseNumber;
        },
        mfHumidity: function() {
          return this.mfCycleRunning && this.deviceTwin.status ? this.deviceTwin.status.setLevelHumidity : 0;
        },
        command: function() {
          return this.mfCycleRunning ? this.commands.functions[String(this.appliance.cycle.functionRunning)] : null;
        },
        limits: function() {
          return this.getLimits(this.appliance.cycle.phaseRunning);
        }
    },
    watch: {
      // 'appliance': 'updateSetpoints',
      // 'deviceTwin.status': 'updateSetpoints',
    },
    created() {
      // setInterval(function() {
      //   // if(this.mfContinuousCycleRunning) {
      //     if(this.progressBar>=100) {
      //       this.progressBar = 0;
      //     }
      //     this.progressBar+=0.25;
      //   // } else {
      //   //   this.progressBar = this.mfPercentage;
      //   // }
      // }.bind(this),10)
      this.applianceService = new ApplianceService();
      this.eventHubListenerService = new EventHubListenerService();
      this.recipeService = new RecipeService();
    },
    mounted() {
      // if(!this.$config.mock) {
        this.reloadAppliance();
      // }
      this.reloadDeviceTwin();
      
    },
    methods: {
      reloadAppliance() {
        this.applianceService.getAppliance(this.personaltoken, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              let appliance = data.body;
              this.$store.commit('appliances/applianceDetails', appliance);
              if(appliance.online) {
                this.reloadRecipeDetails(appliance.cycle.runningCycleId);
                this.eventHubListenerService.postRunLive(this.personaltoken, this.serialNumber)
                  .then((data) => {
                    if(data.code=="200") {
                      console.log("RUN LIVE success")
                    } else {
                      console.error("RUN LIVE ERROR "+JSON.stringify(data));
                    }
                  })
                  .catch(error => {
                    console.error("RUN LIVE ERROR "+error);
                  });
              }
            } else {
              console.error(JSON.stringify(data));
              this.dialog.blockingError = true;
              setTimeout(function() {
                this.$router.push({ name: 'dashboard' });
              }.bind(this),3000);
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
            setTimeout(function() {
              this.$router.push({ name: 'dashboard' });
            }.bind(this),3000);
          });
      },
      reloadDeviceTwin() {
        this.eventHubListenerService.getDeviceTwin(this.personaltoken, this.serialNumber, this.appliance.type)
          .then((data) => {
            if(data.code=="200") {
              let dt = data.body;
              dt.serialNumber = this.serialNumber;
              this.$store.commit('appliances/deviceTwin', dt);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.blockingError = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
          });
      },
      reloadRecipeDetails(runningCycleId) {
        let recipeId = null;
        if(typeof runningCycleId === "number") {
          recipeId = "IRINOX_" + (runningCycleId).toString().padStart(8, '0');
        }
        this.recipeService.getRecipeDetails(this.personaltoken, recipeId ?? runningCycleId, this.serialNumber)
            .then((data) => {
              if(data.code=="200") {
                this.recipe = data.body;
              } else {
                console.error("ERROR "+JSON.stringify(data));
                this.recipe = null;
                this.dialog.error = true;
                setTimeout(function() {
                  this.$functions.historyBack();
                }.bind(this), 3000);
              }
            })
            .catch(error => {
              console.error("ERROR "+error);
              this.recipe = null;
              this.dialog.error = true;
              setTimeout(function() {
                this.$functions.historyBack();
              }.bind(this), 3000);
            });
      },
      carouselReady() {
        this.$refs.phases.goToSlide(this.mfCyclePhaseNumber);
      },
      changeSlide(eventName, params) {
        // console.log(JSON.stringify(params));
        this.currentSlide = params.currentSlide.index;
        this.updateSetpoints();
      },
      updateSetpoints() {
        // if(this.waitingForSaving === null) {
        //   return;
        // }
        this.setpoints = null;
        let phaseType = null;

        if(this.currentSlide === this.mfCyclePhaseNumber) {
          phaseType = this.appliance.cycle.phaseRunning;
          this.setpoints = {
            temperature: this.mfAirSetpoint,
            core: this.mfCoreSetpoint,
            humidity: this.mfHumidity,
            time: this.mfDurationSetpoint,
            fan: this.mfFanLevel,
            phase: this.currentSlide
          };
        } else {
          let phase = this.recipe.phases[this.currentSlide];
          phaseType = phase.type;
          this.setpoints = {
            temperature: phase.set_temp_room*10,
            core: phase.set_temp_probe*10,
            humidity: phase.set_humidity,
            time: phase.set_duration/60,
            fan: phase.set_ventilation,
            phase: this.currentSlide
          };
        }

        if(this.getLimits(phaseType).cellSetTempMin != null && this.setpoints.temperature < this.getLimits(phaseType).cellSetTempMin) {
          this.setpoints.temperature = this.getLimits(phaseType).cellSetTempMin;
        }
        if(this.getLimits(phaseType).cellSetTempMax != null && this.setpoints.temperature > this.getLimits(phaseType).cellSetTempMax) {
          this.setpoints.temperature = this.getLimits(phaseType).cellSetTempMax;
        }

        if(this.getLimits(phaseType).coreProbeSetTempMin != null && this.setpoints.core < this.getLimits(phaseType).coreProbeSetTempMin) {
          this.setpoints.core = this.getLimits(phaseType).coreProbeSetTempMin;
        }
        if(this.getLimits(phaseType).coreProbeSetTempMax != null && this.setpoints.core > this.getLimits(phaseType).coreProbeSetTempMax) {
          this.setpoints.core = this.getLimits(phaseType).coreProbeSetTempMax;
        }

        if(this.getLimits(phaseType).setLevelHumidityMin != null && this.setpoints.humidity < this.getLimits(phaseType).setLevelHumidityMin) {
          this.setpoints.humidity = this.getLimits(phaseType).setLevelHumidityMin;
        }
        if(this.getLimits(phaseType).setLevelHumidityMax != null && this.setpoints.humidity > this.getLimits(phaseType).setLevelHumidityMax) {
          this.setpoints.humidity = this.getLimits(phaseType).setLevelHumidityMax;
        }

        if(this.getLimits(phaseType).phaseDurationSetMin != null && this.setpoints.time < this.getLimits(phaseType).phaseDurationSetMin) {
          this.setpoints.time = this.getLimits(phaseType).phaseDurationSetMin;
        }
        if(this.getLimits(phaseType).phaseDurationSetMax != null && this.setpoints.time > this.getLimits(phaseType).phaseDurationSetMax) {
          this.setpoints.time = this.getLimits(phaseType).phaseDurationSetMax;
        }

        if(this.getLimits(phaseType).evapFanSetSpeedMin != null && this.setpoints.fan < this.getLimits(phaseType).evapFanSetSpeedMin) {
          this.setpoints.fan = this.getLimits(phaseType).evapFanSetSpeedMin;
        }
        if(this.getLimits(phaseType).evapFanSetSpeedMax != null && this.setpoints.fan > this.getLimits(phaseType).evapFanSetSpeedMax) {
          this.setpoints.fan = this.getLimits(phaseType).evapFanSetSpeedMax;
        }

      },

      startProgress() {
        this.endProgress();
        this.waitingForSaving = setTimeout(() => {
          console.log(JSON.stringify(this.setpoints));
          this.saveParameter();
        },2000);
      },
      endProgress() {
        clearTimeout(this.waitingForSaving);
        this.waitingForSaving = null;
      },
      saveParameter() {

        let data = {};

        let phaseType = null;

        if(this.currentSlide === this.mfCyclePhaseNumber) {
          phaseType = this.appliance.cycle.phaseRunning;
        } else {
          phaseType = this.recipe.phases[this.currentSlide].type;
        }

        data.phase = this.setpoints.phase;

        if(this.getLimits(phaseType).cellSetTempMin!=null && this.getLimits(phaseType).cellSetTempMax!=null) {
          data.cellSetTemp = this.setpoints.temperature;
        }

        if(this.getLimits(phaseType).coreProbeSetTempMin!=null && this.getLimits(phaseType).coreProbeSetTempMax!=null) {
          data.coreProbeSetTemp = this.setpoints.core;
        }

        if(this.getLimits(phaseType).evapFanSetSpeedMin!=null && this.getLimits(phaseType).evapFanSetSpeedMax!=null) {
          data.evapFanSetSpeed = this.setpoints.fan;
        }

        // if(this.setpoints.humidity!=this.mfHumidity 
        //     && this.getLimits(phaseType).setLevelHumidityMin!=null && this.getLimits(phaseType).setLevelHumidityMax!=null) {
        //   data.setLevelHumidity = this.setpoints.humidity;
        // }

        if(this.getLimits(phaseType).phaseDurationSetMin!=null && this.getLimits(phaseType).phaseDurationSetMax!=null) {
          data.phaseDurationSet = this.setpoints.time * 60;
        }

        this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
          .then((response) => {
            if(response.code=="200") {
              console.log("Setpoints updated: "+JSON.stringify(data));
              if(this.currentSlide === this.mfCyclePhaseNumber) {
                let dt = this.$functions.clone(this.deviceTwin);
                if(data.cellSetTemp!=null) {
                  dt.status.cellSetTemp = data.cellSetTemp;
                }
                if(data.coreProbeSetTemp!=null) {
                  dt.status.coreProbeSetTemp = data.coreProbeSetTemp;
                }
                if(data.evapFanSetSpeed!=null) {
                  dt.status.evapFanSetSpeed = data.evapFanSetSpeed;
                }
                if(data.setLevelHumidity!=null) {
                  dt.status.setLevelHumidity = data.setLevelHumidity;
                }
                if(data.time!=null) {
                  dt.status.phaseDurationSet = data.phaseDurationSet;
                }
                this.$store.commit('appliances/deviceTwin', dt);
              } else {
                this.recipe.phases[this.currentSlide].set_temp_room = data.cellSetTemp/10;
                this.recipe.phases[this.currentSlide].set_temp_probe = data.coreProbeSetTemp/10;
                this.recipe.phases[this.currentSlide].set_ventilation = data.evapFanSetSpeed;
                this.recipe.phases[this.currentSlide].set_duration = data.phaseDurationSet*60;
                this.recipe.phases[this.currentSlide].set_humidity = data.setLevelHumidity/10;
              }
            } else {
              console.error("EXCEPTION "+JSON.stringify(response));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      phaseTypeClass(t) {
        if(this.isSpecialPhase(t)) {
          return "phase-special";
        }
        if(t==1) {
          return "phase-hot";
        }
        return "phase-cold";
      },
      isSpecialPhase(t) {
        return (t==2 || t==3 || t==4 || t==7 || t==8);
      },
      isCoreVisible(phase) {
        let p = this.command.phases[phase.type];
        return (p && p.coreProbeSetTempMin != null && p.coreProbeSetTempMax!=null);
      },
      isDurationVisible(phase) {
        let p = this.command.phases[phase.type];
        return (p && p.phaseDurationSetMin != null && p.phaseDurationSetMax!=null);
      },
      duration(phase) {
        try {
          //phaseDurationSet is in seconds
          let time = phase.set_duration / 60;
          //time in minutes
          if(time) {
            var hours = Math.floor(time / 60);
            time = time - hours * 60;
            var minutes = Math.floor(time);
            return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
          }
        } catch(err) {
          return "N/A";
        }
      },
      stopCycle() {
        let recipeId = this.appliance.cycle.runningCycleId;
        if(typeof recipeId === "number") {
          recipeId = "IRINOX_" + (recipeId).toString().padStart(8, '0');
        }
        let stopCommand = {
          id: recipeId,
          operationSet: 0
        };
        this.dialog.stop = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, stopCommand)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.stopSuccess = true;
              setTimeout(function() {
                this.$router.push({ name: 'appliance-details', params: { serialNumber: this.serialNumber } });
              }.bind(this),3000);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
      getLimits(phaseType) {
        if(this.mfCycleRunning) {
          try {
            let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
            let p = f.phases[String(phaseType)];
            if(p) {
              let lim = this.$functions.clone(p);
              if(lim.cellSetTempMin) {
                lim.cellSetTempMin*=10;
              }
              if(lim.cellSetTempMax) {
                lim.cellSetTempMax*=10;
              }
              if(lim.coreProbeSetTempMin) {
                lim.coreProbeSetTempMin*=10;
              }
              if(lim.coreProbeSetTempMax) {
                lim.coreProbeSetTempMax*=10;
              }
              return lim;
            }
          } catch(err) {
            console.warn("Error parsing commands " + err);
          }
        }
        return {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            setLevelHumidityMin: null,
            setLevelHumidityMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          };
      }
    }
}
</script>

<style scoped>

.layout-content {
  overflow-x: hidden;
}

</style>

<style>

.cycle-progress-bar {
  margin: 1rem 2rem 0;
  border: 1px solid #002445;
  padding: 1px;
  height: 15px;
}
.phase-progress-bar {
  background: #FFFFFF;
  padding: 0;
  border-left: 1px solid #002445;
}
.phase-progress-bar-done {
  background: #002445;
  border-left: 1px solid #FFFFFF;
}
.phase-progress-bar-running {
  background: #002445;
  height: 100%;
  display: block;
  border-left: 1px solid #FFFFFF;
}

</style>